import vue from 'vue';

export default function buildDeliveryStore(store){
    store.actions.doPay = async (context, params) => await vue.prototype.$myHttp.post('/api/invoices/doPay', params);
    store.actions.rejectPay = async (context, params) => await vue.prototype.$myHttp.post('/api/invoices/rejectPay', params);
    store.actions.doPayStock = async (context, params) => await vue.prototype.$myHttp.post('/api/invoices/doPayStock', params);
    store.actions.createStockInvoice = async (context, params) => await vue.prototype.$myHttp.post('/api/invoices/createStockInvoice', params);
    return store;
}